import React, { useEffect, useRef } from "react"
import { toast } from "react-toastify"
import CabCard from "../../../components/Cards/CabCard"
import { getCabs } from "../../../store/Cab/CabAction"
import { cabAction } from "../../../store/Cab/CAbReducer"
import { useSelector, useDispatch } from "react-redux"
import Loading from "../../../components/Loading"

const CabBox = ({ tripDetails }) => {
  const dispatch = useDispatch()
  const { loading, cabs, error } = useSelector((state) => state.cab)
  const lastToastErrorRef = useRef(null)

  const isRateLimitError =
    error &&
    typeof error === "string" &&
    (error.includes("Rate limit") || error.includes("Maximum"))

  const isDateMissingError = error === "Please select return date and time to see cabs."

  useEffect(() => {
    if (error && lastToastErrorRef.current !== error && !isDateMissingError) {
      lastToastErrorRef.current = error
      toast.error(
        isRateLimitError
          ? "You've exceeded the request limit. Please try again after a few hours."
          : error
      )
    }
    if (!error) lastToastErrorRef.current = null
  }, [error, isRateLimitError, isDateMissingError])

  useEffect(() => {
    const stored = localStorage.getItem("cabSearchResult")
    if (stored) {
      try {
        const parsed = JSON.parse(stored)
        dispatch(cabAction.setCabSearchResult(parsed))
        localStorage.removeItem("cabSearchResult")
      } catch {
        localStorage.removeItem("cabSearchResult")
      }
      return
    }

    const controller = new AbortController()
    const pickupValue = typeof tripDetails?.pickup === 'string'
      ? tripDetails.pickup
      : (tripDetails?.pickup?.label || tripDetails?.pickup || "")
    const dropValue = typeof tripDetails?.drop === 'string'
      ? tripDetails.drop
      : (tripDetails?.drop?.label || tripDetails?.drop || "")

    const tripData = {
      ...tripDetails,
      pickup: pickupValue,
      drop: dropValue,
      phone_number: tripDetails?.phone_number || "",
      signal: controller.signal,
    }

    if (tripData.trip_type === 3 && tripData.round_trip === 1) {
      if (!tripData.return_date || !tripData.return_time) {
        dispatch(cabAction.setCabSearchResult({
          data: [],
          visitorEntryId: "",
          web_trip_unique_id: "",
          distance: ""
        }))
        dispatch({ type: "cabCabs/rejected", payload: "Please select return date and time to see cabs." })
        return () => controller.abort()
      }
    }

    dispatch(getCabs(tripData))
    return () => controller.abort()
  }, [dispatch, tripDetails])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="cabCardBox">
          {cabs?.length > 0 ? (
            <div className="cabCardBox__list">
              {[...cabs]
                .sort((a, b) => (a.vehicle_id || 0) - (b.vehicle_id || 0))
                .map((cab) => (
                  <CabCard
                    key={cab?.id || cab?.vehicle_id}
                    showPrice={true}
                    cab={cab}
                  />
                ))}
            </div>
          ) : isRateLimitError ? (
            <div className="cabCardBox__limitMsg">
              You've exceeded the request limit. Please try again after a few hours.
            </div>
          ) : isDateMissingError ? (
            <div className="cabCardBox__limitMsg" style={{ textAlign: "center", padding: "20px", color: "red", fontWeight: "bold" }}>
              {error}
            </div>
          ) : (
            <div>No cabs available.</div>
          )}
        </div>
      )}
    </>
  )
}

export default CabBox
